import { MenuItem } from '@/core/models';

export class CartEmptyRule {
  /**
   * Evalúa si el carrito está vacío
   */
  public static isSatisfiedBy(items: MenuItem[] | null | undefined): boolean {
    if (!items || items.length === 0) {
      return true;
    }

    return false;
  }
}